import React from 'react';
import Notes from './Notes.jsx';

const ContactNotesIndex = () => {
    return (
        <div>
            <Notes context={"contact"} />
        </div>
    );
}

export default ContactNotesIndex;